(function (angular) {
    'use strict';


    customAttrs.$inject = [
    ];

    function customAttrs(
    ) {

        function link($scope) {
            /**
             * @TODO find a way of passing custom attributes through GET parameters successfully
             */
            $scope.ngModel.custom_attrs = {};
            // filter by custom only and chunk
            $scope.config = chunk($scope.config.filter(function (attr) { return attr.custom === true; }), $scope.chunk || 2);
            $scope.colSize = $scope.colSize || 12 / $scope.chunk;
        }

        function chunk(array, chunk) {
            let j;
            const chunks = [];

            for (let i = 0, j = array.length; i < j; i += chunk) {
                chunks.push(array.slice(i, i + chunk));
            }

            return chunks;
        }

        return {
            link: link,
            restrict: 'E',
            scope: {
                config: '=',
                ngModel: '=',
                filterMode: '=?',
                chunk: '=?',
                colSize: '=?',
            },
            templateUrl: 'directives/custom-attrs.html',
        };
    }

    angular
        .module('app')
        .directive('customAttrs', customAttrs);

}(angular));